export const EMPTY_BODY_METHODS = ['GET', 'DELETE'];

export const HTTP_VERBS = ['DELETE', 'GET', 'POST', 'PUT', 'PATCH'].map(function (verb) {
  return { label: verb, value: verb };
});
